<div class="ai-chatbot-prompt-box-container">
  <ai-chatbot-credits-overlay></ai-chatbot-credits-overlay>
  <div class="ai-chatbot-prompt-box">
    <div class="ai-chatbot-prompt-box-input-area">
      <textarea
        #messageInput
        id="messageInput"
        matInput
        placeholder="Describe your ideal presentation"
        tabindex="0"
        (keydown)="onKeyDown($event)"
        [focusMe]="focus"
      ></textarea>
      <button
        mat-icon-button
        class="ai-chatbot-prompt-box-input-area-send-stop-button"
        aria-label="Send message"
        tabindex="0"
        (click)="sendMessage(messageInput.value)"
        *ngIf="!aiChatbotService.isProcessing"
      >
        <mat-icon svgIcon="ai-chatbot-send"></mat-icon>
      </button>
      <button
        mat-icon-button
        class="ai-chatbot-prompt-box-input-area-send-stop-button"
        aria-label="Stop processing"
        tabindex="0"
        (click)="aiChatbotService.stopProcessing()"
        *ngIf="aiChatbotService.isProcessing"
      >
        <mat-icon svgIcon="ai-chatbot-stop"></mat-icon>
      </button>
    </div>
    <!--
    <div class="ai-chatbot-prompt-box-categories">
      <ai-chatbot-category-chip
        label="Style"
        icon="layout"
        [options]="aiChatbotService.styles"
        (valueChange)="onStyleChange($event)"
      ></ai-chatbot-category-chip>

      <ai-chatbot-category-chip
        label="Content"
        icon="content"
        [options]="aiChatbotService.contents"
        [isMultiSelect]="true"
        (valueChange)="onContentsChange($event)"
      ></ai-chatbot-category-chip>

      <ai-chatbot-category-chip
        label="Industry"
        icon="industry"
        [options]="aiChatbotService.industries"
        (valueChange)="onIndustryChange($event)"
      ></ai-chatbot-category-chip>
    </div>
    -->
    <div class="ai-chatbot-prompt-box-footer">
      <ai-chatbot-branding-toggle></ai-chatbot-branding-toggle>
      <ai-chatbot-mode-toggle></ai-chatbot-mode-toggle>
    </div>
  </div>
  <div class="ai-chatbot-prompt-box-glow"></div>
</div>

<ai-chatbot-suggestions
  (suggestionSelected)="messageInput.value = $event + ' '; messageInput.focus()"
  [class.ai-chatbot-suggestions-not-empty]="!aiChatbotService.isMessagesEmpty()"
></ai-chatbot-suggestions>
